import React from 'react';
import { IconButton, Box, Typography } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import colorConfigs from '../../../configs/colorConfigs';
import { typo } from '../../../assets/fonts/font';

const WhatsAppWidget: React.FC = () => {
  const phoneNumber = '6531298094';
  
  const handleClick = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 1000,
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="caption" sx={{ marginBottom: '4px', ...typo.smallText }}>
        Need Help?
      </Typography>
      <IconButton
        onClick={handleClick}
        sx={{
          backgroundColor: colorConfigs.whatsapp,
          '&:hover': {
            backgroundColor: colorConfigs.whatsapp['&:hover'],
          },
        }}
        aria-label="Chat with us on WhatsApp"
      >
        <WhatsApp fontSize="large" />
      </IconButton>
    </Box>
  );
};

export default WhatsAppWidget;
